export default __webpack_public_path__ + "static/media/copyright.2c94c6e8.svg";